import { Config } from '@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'sessionStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '6fc4e503-41e2-4f0d-a25f-a98fd75389fe',
  redirectUri: 'https://lct-mod-dev.azure.chevron.com',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};

export const environment = {
  calConfig: calConfig,
  production: false,
  envName: 'dev',
  requestTimeout: 30000,
  httpRetryCount: 0,
  fluidLayout: true,
  apiEndpoint: 'https://lct-mod-api-dev.azure.chevron.com/api',
  webUrl: 'https://lct-mod-dev.azure.chevron.com',
  // webUrl: 'https://#######/',
  apiScopes: ['https://lct-test.azure.chevron.com/.default'],
};
